// ABOUTME: Collapsible section component for better content organization
// ABOUTME: Provides expand/collapse functionality with smooth transitions

import React, { useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  icon?: string;
  variant?: 'default' | 'minimal';
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  defaultOpen = true,
  children,
  className = '',
  headerClassName = '',
  icon,
  variant = 'default'
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const buttonStyles = variant === 'minimal'
    ? `w-full flex items-center justify-center gap-2 py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors ${headerClassName}`
    : `w-full flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow ${headerClassName}`;

  const titleStyles = variant === 'minimal'
    ? 'text-sm font-medium'
    : 'text-lg font-semibold text-gray-800';

  return (
    <div className={`mb-6 ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={buttonStyles}
      >
        {variant === 'minimal' ? (
          <>
            <span className="text-sm">{title}</span>
            <span className={`text-gray-400 text-xs transition-transform ${isOpen ? 'rotate-90' : ''}`}>
              ▶
            </span>
          </>
        ) : (
          <>
            <div className="flex items-center gap-3">
              {icon && <span className="text-xl">{icon}</span>}
              <h3 className={titleStyles}>{title}</h3>
            </div>
            <span className={`text-gray-400 transition-transform ${isOpen ? 'rotate-90' : ''}`}>
              ▶
            </span>
          </>
        )}
      </button>

      {isOpen && (
        <div className="mt-2">
          {children}
        </div>
      )}
    </div>
  );
};
